export default {
  colors: undefined,
  name: undefined,
  id: undefined,
  showLogo: false,
  slidesById: {},
  slides: undefined,
  clubId: undefined,
};
